var React = require('react');

function Exit (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"e56f5fd1-10e5-4ca3-84ee-f0e02db52563","data-name":"Group 4220"},[React.createElement("rect",{"x":"5.85","y":"-2.13","width":"1","height":"16.97","transform":"translate(-2.63 6.35) rotate(-45)","key":0}),React.createElement("rect",{"x":"-2.13","y":"5.85","width":"16.97","height":"1","transform":"translate(-2.63 6.35) rotate(-45)","key":1})]));
}

Exit.defaultProps = {"className":"fill-current","id":"a001e41e-7a54-45ad-99fe-4a52bb63bec3","data-name":"Layer 1","viewBox":"0 0 12.71 12.71","width":"100%","height":"100%"};

module.exports = Exit;

Exit.default = Exit;
